import { useLoading } from '../../utils/LoadingProvider';
import { CorreoMarketingApi } from '../../services/api';
import React, { useState, useEffect, useMemo } from 'react';
import { useDialog } from '../../components/Dialogs/Dialogprovider';
import { toast } from 'react-toastify';

export const useCorreosMarketingModel = () =>{
    //nueva campaña
    const [campaignData, setCampaignData] = useState({
        nombre: '',
        tipo: 'todos',
        universidad: '',
        carrera: '',
        plantillaSeleccionada: ''
    });
    //objeto campaña
    /*
    id
    empresa_nombre
    nombre 
    plantilla_id
    filtros_aplicados
    estado 
    total_destinatarios
    fecha_envio
    created_at
    */
    //Destinatarios
    const [destinatarios, setdestinatarios] = useState([]);
    const [Loadingdestinatarios, setLoadingdestinatarios] = useState(false);
    const [errordestinatarios, setErrordestinatarios] = useState(null);
    //Plantillas
    const [plantillas, setplantillas] = useState([]);
    const [Loadingplantillas, setLoadingplantillas] = useState(false);
    const [errorplantillass, setErrorplantillas] = useState(null);

    const { withLoading } = useLoading();
    const { showSuccess, showError, showConfirm } = useDialog();

    //campaña
    const [campanas, setCampanas] = useState([]);
    const [loadingCampanas, setLoadingCampanas] = useState(false);
    const [errorCampanas, setErrorCampanas] = useState(null);

    //logs
    const [logsCorreos, setLogsCorreos] = useState([]);
    const [paginacionLogs, setPaginacionLogs] = useState({ total: 0, page: 1, limit: 20, totalPages: 1 });
    const [loadingLogs, setLoadingLogs] = useState(false);
    const [errorLogs, setErrorLogs] = useState(null);
    

    //obtener destinatarios
    const obtenerDestinatarios = async(nombreEmpresa,tipo,universidad,carrera) =>{
        try{
            setLoadingdestinatarios(true);
            setErrordestinatarios(null);

            console.log("a obtenere destinatarios",nombreEmpresa);
            const response = await CorreoMarketingApi.obtenerDestinatarios(nombreEmpresa,tipo,universidad,carrera);
            console.log("response obtenerDestinatarios",response);
            const data = response.data.data;
            setdestinatarios(data);

            return data;
        }
        catch(error){
            setErrordestinatarios(error);
        }
        finally{
             setLoadingdestinatarios(false);
        }
    }

    //obtener plantillas
    const obtenerPlantillas = async(nombreEmpresa) =>{
        try{
            setLoadingplantillas(true);
            setErrorplantillas(null);
            
            //guardadas en cache 
            //const response = await CorreoMarketingApi.obtenerPlantillas();
            const response = await CorreoMarketingApi.obtenerPlantillasPersonalizadas(nombreEmpresa);
            const data = response.data.data;
            setplantillas(data);

        }
        catch(error){
            setErrorplantillas(error);
        }
        finally{
            setLoadingplantillas(false);
        }
    }
    const plantillasOptions = useMemo(() =>{
       return plantillas?.map(plantilla => ({
          value: plantilla.id, // o materia.id si tienes un ID
          label: plantilla.nombre,
          html: plantilla.contenido_html,    
          json_data: plantilla.contenido_json
        })) || [];
    }, [plantillas]);

    //crear plantilla
    const createPlantilla = async (data) => {
        return await withLoading(async () => {
            try {
            const respuesta = await CorreoMarketingApi.newPlantilla(data);

            if (respuesta.success) {
                toast.success(respuesta.message);
                showSuccess(respuesta.message);
                return true; // Retornamos true para avisarle a la vista que todo salió perfecto
            } else {
                toast.error(respuesta.message || "No se pudo crear la plantilla");
                showError(respuesta.message || "Error al crear");
                return false;
            }
            }
            catch (error) {
            console.error('Error interno:', error);
            // 🌟 CORREGIDO: Ya no es un string harcodeado, lee el error real de la petición
            const msgError = error.response?.data?.message || error.message || "Error de conexión";
            showError(msgError);
            toast.error(msgError);
            throw error;
            }
    }, 'Creando nueva plantilla...') // 🌟 Ajustado a femenino
    };

    //crear campaña
    const createCampana = async (nombreEmpresa, data) => {
        return await withLoading(async () => {
            try {
            const respuesta = await CorreoMarketingApi.createCampana(nombreEmpresa, data);

            if (respuesta.success) {
                toast.success(respuesta.message || "🚀 ¡Campaña despachada con éxito!");
                showSuccess(respuesta.message);
                return respuesta; // Retornamos la respuesta completa (incluye totalEnviados)
            } else {
                toast.error(respuesta.message || "Error al despachar la campaña masiva");
                showError(respuesta.message || "Error");
                return null;
            }
            }
            catch (error) {
            console.error('Error interno al despachar campaña:', error);
            const msgError = error.response?.data?.message || error.message || "Error crítico de conexión";
            showError(msgError);
            toast.error(msgError);
            throw error;
            }
        }, 'Despachando campaña masiva en PostgreSQL...');
    };

    //obtener campañas
    const obtenerCampanas = async (nombreEmpresa) => {
        return await withLoading(async () => {
            try {
            setLoadingCampanas(true);
            setErrorCampanas(null);

            const respuesta = await CorreoMarketingApi.obtenerCampanas(nombreEmpresa);

            if (respuesta.success) {
                setCampanas(respuesta.data); // Guardamos el array de campañas en el estado
                return respuesta.data;
            } else {
                setErrorCampanas(respuesta.message);
                return [];
            }
            }
            catch (error) {
            console.error('Error interno en modelo al obtener campañas:', error);
            setErrorCampanas(error.message);
            throw error;
            } finally {
            setLoadingCampanas(false);
            }
        }, 'Cargando biblioteca de campañas...');
    };

    //logs de correos
    const obtenerLogsCorreos = async (nombreEmpresa, page = 1, limit = 20) => {
        return await withLoading(async () => {
            try {
            setLoadingLogs(true);
            setErrorLogs(null);

            const respuesta = await CorreoMarketingApi.obtenerLogsCorreos(nombreEmpresa, page, limit);

            if (respuesta.success) {
                setLogsCorreos(respuesta.data);
                setPaginacionLogs(respuesta.pagination);
                return respuesta.data;
            } else {
                setErrorLogs(respuesta.message);
                return [];
            }
            } catch (error) {
            console.error("Error de carga en modelo de logs:", error);
            setErrorLogs(error.message);
            throw error;
            } finally {
            setLoadingLogs(false);
            }
        }, 'Sincronizando bitácora global de envíos...');
    };

    return{
        campaignData,
        setCampaignData,

        destinatarios,
        Loadingdestinatarios,
        errordestinatarios,
        obtenerDestinatarios,

        plantillas,
        Loadingplantillas,
        errorplantillass,
        obtenerPlantillas,
        plantillasOptions,

        //crear plantilla
        createPlantilla,

        //crear campaña
        createCampana,
        obtenerCampanas,
        campanas,
        loadingCampanas,
        errorCampanas,

        //logs
        obtenerLogsCorreos,
        logsCorreos,
        paginacionLogs,
        loadingLogs,
        errorLogs
    };
    
}